import styled from "styled-components";
import { fontQuicksand } from '../../common/mixins/mixin';
import { white, deepCoveDark, whiteLilac } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { ContainerWrapper } from "../../common/styled-components/styled-components"
import { device, getWidthRange, breakpoints } from '../../../../app/js/utils/responsive_utilities'

export const Wrapper = styled(ContainerWrapper)`
    width: 100%;
    height: 20.6rem;
    background: ${props => props.showPurchaseFooter ? deepCoveDark : whiteLilac};
    @media ${device.Phone}{
      display : ${props => props.passwordScreen ? 'none' : 'block'};
}
`

export const ImageWrapper = styled.div`
  width: 19.4rem;
  margin: auto;
  padding-top: ${props => props.passwordScreen ? '10rem' : props.showPurchaseFooter ? '3rem'  : '8.7rem'};
  img{
    width: 100%;
    height: 100%;
  }
`

export const LinkBox = styled.div`

`

export const FooterNotes = styled.div`
  margin-top: 0.8rem;
  text-align: center;
  ${fontQuicksand(1.2, 1.6)}
  color: ${props => props.showPurchaseFooter ? white : deepCoveDark};
  /* ${props => props.showPurchaseFooter ? 'max-width: 32rem; margin: 1.8rem auto 0;' : ''} */
  p{
    ${fontQuicksand(1.4, 1.6, 3)}
    ${props => props.showPurchaseFooter ? fontQuicksand(1.2, 1.6, 4) : ''}
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    
  }
  a{
    font-weight: bold;
    color: ${props => props.showPurchaseFooter ? white : deepCoveDark};
    ${props => props.showPurchaseFooter ? fontQuicksand(1.2, 1.6, 7) : ''};
    text-decoration: underline;
  }
`;